import { PropsWithChildren, ReactNode, useMemo } from 'react';
import { useCan } from '../hooks/use-can';
import { Permission, PermissionScope } from '../types';

export interface PermissionBoundaryProps extends PropsWithChildren {
  permissionsRequired: Permission[] | Permission;
  placeholder?: ReactNode;
  operator?: 'AND' | 'OR';
  scope?: PermissionScope;
}

export const PermissionBoundary = ({
  permissionsRequired,
  operator = 'AND',
  placeholder = null,
  scope = 'organization',
  children,
}: PermissionBoundaryProps) => {
  const can = useCan({ scope });

  const hasUserPermissions = useMemo(
    () =>
      can({
        permissions: permissionsRequired,
        operator,
      }),
    [can, operator, permissionsRequired]
  );

  return hasUserPermissions ? <>{children}</> : placeholder;
};
